import { Navigate, type RouteObject } from 'react-router'

import { lazyRoute } from '@web/app/routes/lazy-route'
import {
  ConditionRoute,
  EquipmentRoute,
  ResultsGroupRoute,
  ResultsMachineRoute
} from '@web/shared/constants/routes.constant'

const integralGroupRoute = lazyRoute(
  () => import('@web/pages/results-integral-group/ui/integral-group-page'),
  ({ IntegralGroupPage }) => IntegralGroupPage
)

const workModeRoute = lazyRoute(
  () => import('@web/pages/condition-work-mode/ui/work-mode-page'),
  ({ WorkModePage }) => WorkModePage
)

const kinematicRoute = lazyRoute(
  () => import('@web/pages/condition-kinematic/ui/kinematic-condition-page'),
  ({ KinematicConditionPage }) => KinematicConditionPage
)

const mnemonicPageRoute = lazyRoute(
  () => import('@web/pages/mnemonic/ui/mnemonic-page'),
  ({ MnemonicPage }) => MnemonicPage
)

const mnemonicRoute = lazyRoute(
  () => import('@web/widgets/mnemonic/ui/mnemonic'),
  ({ Mnemonic }) => Mnemonic
)

const machineDescriptionRoute = lazyRoute(
  () => import('@web/pages/condition-description/ui/machine-description'),
  ({ MachineDescription }) => MachineDescription
)

const ConditionRouter: RouteObject[] = [
  {
    path: EquipmentRoute.GroupId,
    children: [
      {
        path: ConditionRoute.Results,
        children: [
          {
            index: true,
            element: <Navigate to={ResultsGroupRoute.ResultsSummary} replace />
          },
          {
            path: ResultsGroupRoute.ResultsSummary,
            lazy: integralGroupRoute
          },
          {
            path: ResultsGroupRoute.ResultsObjects,
            lazy: integralGroupRoute
          }
        ]
      }
    ]
  },
  {
    path: EquipmentRoute.MachineId,
    children: [
      {
        path: ConditionRoute.Results,
        children: [
          {
            index: true,
            lazy: lazyRoute(
              () =>
                import(
                  '@web/pages/results-integral-machine/ui/integral-machine-page'
                ),
              ({ IntegralMachineIndex }) => IntegralMachineIndex
            )
          },
          {
            path: ResultsMachineRoute.Summary,
            lazy: lazyRoute(
              () =>
                import(
                  '@web/pages/results-integral-machine/ui/integral-machine-summary'
                ),
              ({ IntegralMachineSummary }) => IntegralMachineSummary
            )
          },
          {
            path: ResultsMachineRoute.Conclusion,
            lazy: lazyRoute(
              () =>
                import(
                  '@web/pages/results-integral-machine-conclusion/ui/integral-machine-conclusion'
                ),
              ({ IntegralMachineConclusion }) => IntegralMachineConclusion
            )
          }
        ],
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/results-integral-machine/ui/integral-machine-page'
            ),
          ({ IntegralMachinePage }) => IntegralMachinePage
        )
      },
      {
        path: ConditionRoute.WorkMode,
        lazy: workModeRoute
      },
      {
        path: ConditionRoute.KinematicsDiagram,
        lazy: kinematicRoute
      },
      {
        path: ConditionRoute.MnemonicDiagram,
        lazy: mnemonicPageRoute,
        children: [
          {
            path: ':mnemoSchemeId',
            lazy: mnemonicRoute
          }
        ]
      },
      {
        path: ConditionRoute.Description,
        lazy: machineDescriptionRoute
      }
    ]
  },
  {
    path: EquipmentRoute.PointId,
    children: [
      {
        path: ConditionRoute.Results,
        lazy: lazyRoute(
          () =>
            import('@web/pages/results-integral-point/ui/integral-point-page'),
          ({ IntegralPointPage }) => IntegralPointPage
        )
      },
      {
        path: ConditionRoute.WorkMode,
        lazy: workModeRoute
      },
      {
        path: ConditionRoute.KinematicsDiagram,
        lazy: kinematicRoute
      },
      {
        path: ConditionRoute.MnemonicDiagram,
        lazy: mnemonicPageRoute,
        children: [
          {
            path: ':mnemoSchemeId',
            lazy: mnemonicRoute
          }
        ]
      },
      {
        path: ConditionRoute.Description,
        lazy: machineDescriptionRoute
      }
    ]
  },
  {
    path: EquipmentRoute.MeasurementId,
    children: [
      {
        path: ConditionRoute.Results,
        lazy: lazyRoute(
          () =>
            import('@web/pages/results-measurement/ui/results-measumrent-page'),
          ({ ResultsMeasurementPage }) => ResultsMeasurementPage
        )
      },
      {
        path: ConditionRoute.WorkMode,
        lazy: workModeRoute
      },
      {
        path: ConditionRoute.KinematicsDiagram,
        lazy: kinematicRoute
      },
      {
        path: ConditionRoute.MnemonicDiagram,
        lazy: mnemonicPageRoute,
        children: [
          {
            path: ':mnemoSchemeId',
            lazy: mnemonicRoute
          }
        ]
      },
      {
        path: ConditionRoute.Description,
        lazy: machineDescriptionRoute
      }
    ]
  }
]

export default ConditionRouter
